import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight';

// this is the only place we should be importing these
import { Button, ButtonType } from './Button';

type Props = {
  bookingVerticalTypeId?: number;
  containerClass?: string;
  handleClickViewResults(bookingVerticalTypeId: number | undefined): void;
}

const MoreResultsButton = (props: Props): JSX.Element => {
  const { t } = useTranslation();
  const { bookingVerticalTypeId, containerClass, handleClickViewResults } = props;

  return (
    <div className={`flex md:justify-self-end h-fit ${containerClass}`}>
      <Button
        buttonType={ButtonType.secondary}
        className='w-full md:w-fit'
        onClick={() : void => handleClickViewResults(bookingVerticalTypeId)}
      >
        {t('dashboard.widgets.seeMoreResults')}
        <FontAwesomeIcon icon={faAngleRight} className='pl-2 m-[-1px]' />
      </Button>
    </div>
  );
};

export { MoreResultsButton };
